import * as React from "react";
import { singleton } from "logic/singleton";
const FieldTypesContext = React.createContext(void 0);
export default singleton("contexts.FieldTypesContext", () => FieldTypesContext);
